import React from 'react';
import axios from 'axios';
import { Card,Avatar} from 'antd';
import { Form, Input, Button,Select,Spin,Switch } from 'antd';
import {
    Col,
    Row,
  } from 'reactstrap';
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''

class MemberTypeDetail extends React.Component{

    state={
        membertype: {},
        type_name:'',
        minimum_savings_balance:0,
        deposit_charges:0,
        minimum_account_deposit:0,
        savings_withdraw_charges:0,
        datarequested:true,

        account_monthly_interest_rate:0,
        minimum_accnt_bal_forintrest:0,
        minimum_age:0,
        showeditablesavings_withdrawcharge:false
    }
    


    componentDidMount(){
        if(localStorage.getItem("token")){
          token= localStorage.getItem("token")
        }else{
          token= ''
        }

        axios.defaults.headers={
          "Content-Type":"application/json",
          Authorization:`Token ${token}`
        }

        const membertypeID=this.props.match.params.membertypeID;
        axios.get(`${serverconfig.backendserverurl}/api/membertypes/${membertypeID}`)
        .then(res => {  
            this.setState({membertype: res.data})

            this.setState({type_name: res.data.type_name})
            this.setState({minimum_savings_balance: res.data.minimum_savings_balance})
            this.setState({deposit_charges: res.data.deposit_charges})
            this.setState({minimum_account_deposit: res.data.minimum_account_deposit})
            this.setState({savings_withdraw_charges: res.data.savings_withdraw_charges})

            this.setState({account_monthly_interest_rate: res.data.account_monthly_interest_rate})
            this.setState({minimum_accnt_bal_forintrest: res.data.minimum_accnt_bal_forintrest})
            this.setState({minimum_age: res.data.minimum_age})

            this.setState({showeditablesavings_withdrawcharge: res.data.showeditablesavings_withdrawcharge})

            this.setState({datarequested:false})

        })
    }

    //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    const membertypeID=this.props.match.params.membertypeID;
    let form_data = new FormData();

    form_data.append('type_name', this.state.type_name);
    form_data.append('minimum_savings_balance', this.state.minimum_savings_balance);
    form_data.append('deposit_charges', this.state.deposit_charges);
    form_data.append('minimum_account_deposit', this.state.minimum_account_deposit);
    form_data.append('savings_withdraw_charges', this.state.savings_withdraw_charges);

    form_data.append('account_monthly_interest_rate', this.state.account_monthly_interest_rate);
    form_data.append('minimum_accnt_bal_forintrest', this.state.minimum_accnt_bal_forintrest);
    form_data.append('minimum_age', this.state.minimum_age);
    form_data.append('showeditablesavings_withdrawcharge', this.state.showeditablesavings_withdrawcharge);


    axios.put(serverconfig.backendserverurl+`/api/membertypes/${membertypeID}/`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>this.setState({datarequested:false}),window.location.reload(false)

  )
  .catch(error => console.log(error))

  }



  handletype_nameChange= (e) => this.setState({ type_name: e.target.value});
  handleminimum_account_balanceChange= (e) => this.setState({ minimum_account_balance: e.target.value});
  handledeposit_chargesChange= (e) => this.setState({ deposit_charges: e.target.value});
  handleminimum_account_depositChange= (e) => this.setState({ minimum_account_deposit: e.target.value});
  handlewithdraw_chargesChange= (e) => this.setState({ withdraw_charges: e.target.value});
  handlewithdrawals_per_monthChange= (e) => this.setState({ withdrawals_per_month: e.target.value});
  handleaccount_fine_feeChange= (e) => this.setState({ account_fine_fee: e.target.value});
  handleaccount_transfer_chargeChange= (e) => this.setState({ account_transfer_charge: e.target.value});
  handleaccount_monthly_chargeChange= (e) => this.setState({ account_monthly_charge: e.target.value});
  handleaccount_monthly_interest_rateChange= (e) => this.setState({ account_monthly_interest_rate: e.target.value});
  handleaccount_statement_feeChange= (e) => this.setState({ account_statement_fee: e.target.value});
  handlecheque_deposit_feeChange= (e) => this.setState({ cheque_deposit_fee: e.target.value});


    render(){

        if(this.state.datarequested===true){
            return(
              <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin indicator={antIcon} />
              </div>
            )
      
          }else{

            return(
                <div>
        
        <Row>
        <Col xs="12" sm="6" lg="6">

        <Card 
          style={{padding:10}}
          hoverable>
            <h4>Member Type Details / Update</h4>
            <Form
                onFinish={(event) => this.handleFormSubmit(event)} 
                >
              <FormItem label="Type Name"
                     
            >
              <Input name="type_name"  placeholder="Put a name here." value={this.state.type_name} onChange={this.handletype_nameChange} />
            </FormItem>

            <FormItem label="Minimum Savings Balance"
                     
            >
              <Input name="minimum_savings_balance"  placeholder="0.00" value={this.state.minimum_savings_balance} onChange={(val)=>{this.setState({minimum_savings_balance:val.target.value})}} />
            </FormItem>
  
            <FormItem label="Deposit Charges"
                    
            >
              <Input name="deposit_charges"  placeholder="0.00" value={this.state.deposit_charges} onChange={this.handledeposit_chargesChange} />
            </FormItem>
  
            <FormItem label="Minimum Account Deposit">
              <Input name="minimum_account_deposit"  placeholder="0.00" value={this.state.minimum_account_deposit} onChange={this.handleminimum_account_depositChange} />
            </FormItem>


            <FormItem label="Savings Withdraw Charges">
              <Input name="savings_withdraw_charges"  placeholder="0.00" value={this.state.savings_withdraw_charges} onChange={(val)=>{this.setState({savings_withdraw_charges:val.target.value})}} />
            </FormItem>


            <FormItem label="Savings annual interest rate"
                   
            >
              <Input name="account_monthly_interest_rate"  placeholder="0.00" value={this.state.account_monthly_interest_rate} onChange={(val)=>{this.setState({account_monthly_interest_rate:val.target.value})}} />
            </FormItem>

            <FormItem label="Minimum savings accnt_bal for intrest"
                       
            >
              <Input name="minimum_accnt_bal_forintrest"  placeholder="0.00" value={this.state.minimum_accnt_bal_forintrest} onChange={(val)=>{this.setState({minimum_accnt_bal_forintrest:val.target.value})}} />
            </FormItem>


            <FormItem label="Minimum member age"
                     
            >
              <Input name="minimum_age"  placeholder="0.00" value={this.state.minimum_age} onChange={(val)=>{this.setState({minimum_age:val.target.value})}} />
            </FormItem>

            <Form.Item label="showeditablesavings_withdrawcharge?">
              <Switch
                  checked={this.state.showeditablesavings_withdrawcharge}
                  onChange={val=>{this.setState({showeditablesavings_withdrawcharge:val})}}
                  checkedChildren="True"
                  unCheckedChildren="False"
                  />
            </Form.Item>


            <FormItem>
                <Button  type="primary" htmlType="submit">Update</Button>
            </FormItem>
            </Form>
          
          </Card>
          
        </Col>
      
        </Row>
      
          </div>
            )

          }

        
    }
}

export default MemberTypeDetail; 